import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatTableDataSource } from '@angular/material';
import { pgiAuthors } from 'src/app/models/authors';
import { CalcHeaders } from 'src/app/models/calcHeader';

@Component({
  selector: 'app-modal-window',
  templateUrl: './modal-window.component.html',
  styleUrls: ['./modal-window.component.css']
})
export class ModalWindowComponent implements OnInit {

  displayedColumns = ['lp', 'twrCode', 'provisionPercent', 'quantity', 'provisionValue', 'grossValue', 'correction', 'note'];

  constructor(
    public dialogRef: MatDialogRef<ModalWindowComponent>,

    @Inject(MAT_DIALOG_DATA) public data: CalcHeaders) {
     }

  ngOnInit() {

  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}
